import { MapPinHouseIcon } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { PickupPointBlockEditor } from "./editor";
import { PickupPointBlockEmail } from "./email";
import type { PickupPointBlockProps } from "./types";
import { PickupPointWeb } from "./web";
import { PickupPointWebEditor } from "./web-editor";
import { PickupPointEmailPanelRenderer } from "./email-panel";


export default registerBlock<PickupPointBlockProps>({
  type: "pickup-point",
  name: "editorBlocksLibrary.blocks.pickup-point.title",
  description: "editorBlocksLibrary.blocks.pickup-point.description",
  Icon: MapPinHouseIcon,
  category: BlockCategory.TRACKING,
  hasDynamicContent: true,
  components: {
    email: {
      component: PickupPointBlockEmail,
      editor: {
        component: PickupPointBlockEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: PickupPointEmailPanelRenderer,
      },
    },
    web: {
      component: PickupPointWeb,
      editor: {
        component: PickupPointWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
      },
    },
  },
});
